import { applyMiddleware, createStore } from "redux";
import { thunk } from "redux-thunk";
let i=1;

const initialstate={
    todos:[],
    nextId:i++
}
// state.todos=[{id:3,title:"test"}]
export const todoReducer=(state=initialstate,action)=>{
    switch(action.type){
        case "addtodo":{
            const newTodo={id:state.nextId,title:action.payload.title};
            return {
                ...state,todos:[...state.todos,newTodo],nextId:state.nextId+1
            }
        }
        case "edittodo":{
            return {
                ...state,
                todos:state.todos.map((todo)=>todo.id===action.payload.id?{...todo,title:action.payload.title}:todo)
            }
        }
        case "deletetodo":{
            return {
                ...state,
                todos:state.todos.filter((todo)=>todo.id!==action.payload)
            }
        }
        default :
        return state
    }}

    let store2=createStore(todoReducer,applyMiddleware(thunk))

    export default store2